<template>
	<main id="subPage" class="admin">
		<!-- 카테고리 -->
        <section id="category">
			<h2>관리자 메뉴</h2>
			<ul class="breadCrumb">
				<li class="home"></li>
				<li class="web">
					<p class="pageTxt">관리자 메뉴</p>
					<ul class="depth">
						<li><router-link to="/generalmembership" title="관리자 메뉴">관리자 메뉴</router-link></li>
						<li><router-link to="/usermanagement" title="시스템 관리">시스템 관리</router-link></li>
					</ul> 
				</li>
                <li class="web">
					<p class="pageTxt">게시판 관리</p>
					<ul class="depth">
						<li><router-link to="/generalmembership" title="회원관리">회원관리</router-link></li>
						<li><router-link to="/discountvehicle" title="할인차량관리">할인차량관리</router-link></li>
						<li><router-link to="/periodparking" title="정기권 주차장관리">정기권 주차장관리</router-link></li>
                        <li><router-link to="/noticemanagement" title="게시판관리">게시판관리</router-link></li>
						<li><router-link to="/popuplist" title="팝업/배너관리">팝업/배너관리</router-link></li>
					</ul> 
				</li>
                <li>
					<p class="pageTxt">공지사항 관리</p>
					<ul class="depth">
						<li><router-link to="/noticemanagement" title="공지사항 관리">공지사항 관리</router-link></li>
						<li><router-link to="/faqmanagement" title="자주묻는질문 관리">자주묻는질문 관리</router-link></li>
					</ul> 
				</li>
			</ul>
        </section>

		<!-- 컨텐츠 영역 -->
		<section id="content">
			<div class="inner">
				<h3 class="pageTitle">공지사항 수정</h3>
                <article>
                    <!--table-->
                    <div class="table horizontal-table">
                        <table>
                            <caption>공지사항 수정 테이블</caption>
                            <colgroup>
                                <col style="width: 15%; min-width: 80px;">
                                <col style="width: auto;">
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th scope="row">제목<span class="redDot">*</span></th>
                                    <td>
                                        <input type="text" title="제목 입력" v-model="title" placeholder="제목을 입력 해 주세요.">
                                        <div class="error" v-if="!$v.title.required">필수 입력란입니다.</div>
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row">내용<span class="redDot">*</span></th>
                                    <td>
                                        <ckeditor :editor="editor" v-model="cts" :config="editorConfig" @ready="onReady"></ckeditor>
                                        <div class="error" v-if="!$v.cts.required">필수 입력란입니다.</div>
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row">첨부파일</th>
                                    <td>
                                        <div class="fileArea">
                                            <p class="upload-name"></p>
                                            <input type="file" class="hidden" id="file" ref="files" @change="changeFile" @click="resetFile"/>
                                            <div>{{ firstName }}({{eFiles.size | bytes('MB')}})</div>
                                            <label for="file" class="btn gray">파일첨부</label>
                                        </div>
                                        <div v-for="(item, index) in existFiles" :key="index" style="display:flex; flex-direction:column; align-items:flex-start;">
                                          <span class="cursor"  @click="downloadAttachFile(item.filePath, item.saveNm, item.viewNm, item.fileExt, item.repoId)">
                                            {{ item.viewNm }} ({{ item.fileSize | comma }})kb
                                          </span>
                                          <button type="button" @click="deleteAttachFile(item.filePath, item.saveNm, item.atchFileId, item.fileExt, item.repoId)" class="btn gray" style="margin: 6px 0 0 0;">첨부파일 삭제</button>
                                        </div>
                                        <p class="info">첨부파일 (최대용량:20M) *이미지 파일 (jpg, jpeg, gif, png, pdf)</p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <!--table-->
                </article>
                <article class="btnArea">
                    <button class="btn border" @click="cancelBtn">목록</button>
                    <button class="btn gray" @click="goBackConfirm">취소</button>
                    <button :disabled="isLoading" v-if="isLoading" class="btn blue"><LoadingSpinner /></button>
                    <button :disabled="isLoading" v-if="!isLoading" class="btn blue" @click="updateBtn">저장</button>
                </article>
                <article>
                    <!--table-->
                    <div class="table horizontal-table">
                        <table>
                            <caption>공지사항 수정 테이블</caption>
                            <colgroup>
                                <col style="width:10%; min-width: 80px;"/>
                                <col style="width:15%"/>
                                <col style="width:10%; min-width: 80px;"/>
                                <col style="width:15%"/>
                                <col style="width:10%; min-width: 80px;"/>
                                <col style="width:15%"/>
                                <col style="width:10%; min-width: 80px;"/>
                                <col style="width:15%"/>
                            </colgroup>
                            <tbody>
                                <tr style="border-top: 1px solid #E0E0E0;">
                                    <th scope="row">작성자</th>
                                    <td><input type="text" v-model="regNm" readonly></td>
                                    <th scope="row">작성일</th>
                                    <td>{{ timestamp(regDttm) }}</td>
                                    <th scope="row">수정자</th>
                                    <td><input type="text" v-model="updNm" readonly></td>
                                    <th scope="row">수정일</th>
                                    <td>{{ timestamp(now) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <!--//table-->

                </article>
            </div>
        </section>
	</main>
</template>

<script>
import axios from "../../../util/axios";
import { required }  from 'vuelidate/lib/validators'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import CKEditor      from '@ckeditor/ckeditor5-vue2';
import '@ckeditor/ckeditor5-build-classic/build/translations/ko';
const uploadAdapter = require("../../../assets/js/UploadAdapter");
import moment, { now } from 'moment';
import LoadingSpinner from '../../../components/LoadingSpinner.vue';
export default {
  name: 'ckeditorTA',
	data(){
		return{
      cts                : '',
			title              : '',
			bbsCd              : 'notice',
			eFiles             : {size:0},
			editor             : ClassicEditor,
      menuUrl            : "/api/admin/board/notice",
			atclId             : '',
			existFiles         : '',
			submitStatus       : '',
			isLoading          : false,
      regNm              : '',
			editorConfig       : {
				language         : 'ko',
				enterMode        : 2,
				shiftEnterMode   : 3,
				extraPlugins     : [ uploadAdapter.MyCustomUploadAdapterPlugin ],
				mediaEmbed       : {
					previewsInData : true,
				}
			},
      updDttm             : '',
      updNm               : '',
		}
	},

    validations: {
		title : {
			required
		},
		cts   : {
			required
		}
	},

	components : {
		ckeditor : CKEditor.component,
		LoadingSpinner,
	},

	mounted(){
        const data = this.$route.params.data;
        if(!data) {
			alert("잘못된 접근입니다.");
			this.$router.push('/noticemanagement');
            return;
        }
        this.atclId     = data.atclId;
		this.title      = data.title;
		this.cts        = data.cts;
		this.existFiles = data.eFiles;
        this.initAttachList();

	},
  computed :{
    now(){
      return Date.now();
    }
  },
	methods : {
    timestamp(day){
      return moment(day).format('YYYY-MM-DD');
    },

    async initAttachList(){
            const res = await axios('get', "/api/admin/board/notice/getAttachList.json", {
                atclId: this.atclId
            });
            const data = res.data;
			this.existFiles = data.attachList;
		},

        onReady(editor){
			editor.ui.getEditableElement().parentElement.insertBefore(
				editor.ui.view.toolbar.element,
				editor.ui.getEditableElement()
			);
		},

      changeFile(e) {
        const file = e.target.files[0];

        if (file.size > 2000000) {
          alert('최대 20mb까지 업로드할 수 있습니다.');
          this.resetFile();
          return;
        }

        if (file['type'] === 'image/jpeg' || file['type'] === 'image/png' || file['type'] === 'image/gif' || file['type'] === 'image/jpg' || file['type'] === 'image/pdf' || file['type'] == 'application/pdf') {
          this.firstName = file.name;
          this.eFiles = file;
        }
		},

		resetFile(){
			this.$refs.files.value = '';
			this.eFiles = [];
		},

		downloadAttachFile(filePath, saveNm, viewNm, fileExt, repoId) {
			location.href = this.menuUrl + "/download.json?filePath=" + filePath + "&saveNm=" + saveNm + "&viewNm=" + viewNm + "&fileExt=" + fileExt + "&repoId=" + repoId;
		},

		async deleteAttachFileRaw(filePath, saveNm, atchFileId, fileExt, repoId){
			let apiParams = new FormData();
			apiParams.append("filePath", filePath);
			apiParams.append("saveNm", saveNm);
			apiParams.append("atchFileId", atchFileId);
			apiParams.append("fileExt", fileExt);
			apiParams.append("repoId", repoId);
			await axios('post', this.menuUrl + "/deleteAttachFile.json", apiParams);
		},

		async deleteAttachFile(filePath, saveNm, atchFileId, fileExt, repoId){
			await this.deleteAttachFileRaw(filePath, saveNm, atchFileId, fileExt, repoId);
			await this.initAttachList();
		},

    initEFiles(){
			if(this.existFiles.length == 0){
				this.existFiles = '';
			}
		},

    async updateBtn() {
      if (this.$v.$invalid) {
        return;
      }
      this.isLoading = true;

      try {
        this.initEFiles();

        // 새 파일을 첨부한 경우, 기존 첨부파일은 모두 삭제하고 새 파일로 교체
        if (this.eFiles instanceof File && this.existFiles && this.existFiles.length > 0) {
          for (const item of this.existFiles) {
            await this.deleteAttachFileRaw(item.filePath, item.saveNm, item.atchFileId, item.fileExt, item.repoId);
          }
        }

        let apiParams = new FormData();
        apiParams.append("atclId", this.atclId);
        apiParams.append("title", this.title);
        apiParams.append("cts", this.cts);
        if (this.eFiles instanceof File) {
          apiParams.append("files", this.eFiles);
        }

        await axios('post', "/api/admin/board/notice/updateAction.json", apiParams);
        await this.$router.push('noticemanagement');
      } finally {
        this.isLoading = false;
      }
    },

    cancelBtn(){
      this.$router.push('noticemanagement');
      localStorage.clear();
    },
    goBack(){
      this.$router.go(-1);
      localStorage.clear();
    },

    goBackConfirm(){
      this.$confirm(
        {
          message: `취소하시겠습니까?`,
          button: {
            no: '아니오',
            yes: '예'
          },
          callback: confirm => {
            if (confirm) {
              this.goBack();
            }
          }
        }
      )
    },

  },
  created() {
    var data = this.$route.params.data;

    if(data == null){
      data = JSON.parse(localStorage.getItem("noticeManageData"));
    }else{
      localStorage.setItem("noticeManageData", JSON.stringify(data));
    }
    this.atclId     = data.atclId;
    this.title      = data.title;
    this.cts        = data.cts;
    this.existFiles = data.eFiles;
    this.regNm      = data.regNm;
    this.regDttm    = data.regDttm;
  },
}
</script>

